export const defaultFaIconCx =
  'cursor-pointer text-[18px] hover:opacity-70 transition-opacity duration-150'
